import { VenueReadiness } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityReadinessPage() {
  return <VenueReadiness />;
}